import devNote from '@xingternal/dev-note';

export { default as Paragraph, default as P } from './Paragraph';
export { default as Headline, default as H } from './Headline';
export { default as Display, default as D } from './Display';
export { default as List } from './List';
export { default as ListItem } from './ListItem';

devNote.deprecate(
  `The component @xingternal/malt-typography is deprecated and should be replaced as soon as possible with @xingternal/typography. More information on https://brewery.xing.io/typography/.`
);
